import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
let router = new Router({
  routes: [
    {
      path: "*",
      redirect: "/"
    }
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

if (process.env.VUE_APP_IS_BROWSER === "true") {
  router.addRoutes([
    {
      path: "/",
      name: "landing",
      component: () => import("./views/LandingPage.vue")
    },
    {
      path: "/map",
      name: "map",
      component: () => import("./views/BrowserHome.vue")
    }
  ]);
} else {
  router.addRoutes([
    {
      path: "/",
      name: "landing",
      component: () => import("./views/WallHome.vue")
    },
    {
      path: "/title",
      name: "title",
      component: () => import("./views/TitleLarge.vue")
    },
    {
      path: "/twitter",
      name: "twitter",
      component: () => import("./views/Twitter.vue")
    },
    {
      path: "/liveEarth",
      name: "liveEarth",
      component: () => import("./views/LiveEarth.vue")
    },
    {
      path: "/bookend",
      name: "bookend",
      component: () => import("./views/BookEnd.vue")
    }
  ]);
}
export default router;
